/**
 * Created by fers on 26.09.15.
 */

import { declareEntity } from '../fw/MetaDataHelper';
import { v4 as uuidv4 } from 'uuid';

export default declareEntity({
    entity: "databases",
    graphQL: "Database",
    name: "Databases",
    dynamoPrefix: 'sys',
    storageType: 'schema',
    userEditable: false,
    fields: (types) => { return {
        id: {
            name: "ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        name: {
            name: "Name",
            type: "string",
            trim: true,
            defaultValue: "",
            required: true,
        },
        connectionInfo: {
            name: "Connection Info",
            type: "object",
            trim: true,
            defaultValue: "",
            required: true,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            filterable: true,
            userEditable: false,
        },

    }; },
    relations: (types) => { return {
    }; }
});
